import classNames from 'classnames'

function FormSubmit({valid}) {
  return (
    <div className="o-form-button-bar">
      <input className="button button-primary" type="submit" value="Register using HCLSoftware ID"/>
    </div>
  )
}

export default FormSubmit;
